<template>
  <v-container fluid>
    <breadcrumbs />

    <h1 class="mb-4">
      Подключение филиалов
    </h1>

    <v-card>
      <v-card-title>
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="search"
              label="Поиск по филиалу"
              append-icon="mdi-magnify"
              outlined
              single-line
              hide-details
              clearable
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-switch
              v-model="onlyNotConnected"
              label="Только неподключённые"
              hide-details
              class="mt-0"
              @change="load"
            />
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        fixed-header
        :headers="headers"
        :items="filteredItems"
        :loading="loading"
        no-data-text="Филиалы не найдены"
        @click:row="openCard"
      >
        <!-- eslint-disable-next-line -->
        <template #item.connection="{ item }">
          <v-chip :color="item.isConnected ? 'success' : 'error'" small dark>
            {{ connectionLabel(item) }}
          </v-chip>
        </template>

        <!-- eslint-disable-next-line -->
        <template #item.jupiterSync="{ item }">
          {{ item.jupiterSync ? 'Включён' : 'Отключён' }}
        </template>

        <!-- eslint-disable-next-line -->
        <template #item.actions="{ item }">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <v-btn
                color="primary"
                class="filial-connection__action"
                elevation="1"
                small
                v-bind="attrs"
                v-on="on"
                @click.stop="openCard(item)"
              >
                <v-icon small>
                  mdi-open-in-app
                </v-icon>
              </v-btn>
            </template>
            <span>Подключение филиала</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import snackbarMessage from '@/mixins/snackbar-message'
  import RouteName from '@/models/enums/RouteName'
  import filialConnectionApi from '@/api/administration/filialConnection'

  export default {
    name: 'FilialConnectionIndex',
    mixins: [snackbarMessage],
    data () {
      return {
        items: [],
        loading: false,
        search: '',
        onlyNotConnected: false,
        headers: [
          { text: 'Филиал', value: 'name' },
          { text: 'Регион', value: 'regionName' },
          { text: 'Организация', value: 'organizationName' },
          { text: 'Подключение', value: 'connection', sortable: false },
          { text: 'Юпитер', value: 'jupiterSync' },
          { text: 'Действия', value: 'actions', align: 'end', sortable: false },
        ],
      }
    },
    computed: {
      filteredItems () {
        // clearable сбрасывает v-model в null, а не в '' — .trim() на null упадёт
        const query = (this.search || '').trim().toLowerCase()
        if (!query) return this.items

        return this.items.filter((item) => (item.name || '').toLowerCase().includes(query))
      },
    },
    created () {
      this.load()
    },
    methods: {
      async load () {
        this.loading = true
        try {
          this.items = await filialConnectionApi.fetchFilials({ onlyNotConnected: this.onlyNotConnected })
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.loading = false
      },
      connectionLabel (item) {
        if (!item.isConnected || !item.connectionDate) return 'Не подключён'

        const date = new Date(Date.parse(item.connectionDate)).toLocaleDateString('ru-RU')
        return `Подключён ${date}`
      },
      openCard (item) {
        this.$router.push({
          name: RouteName.AdministrationFilialConnectionCard,
          params: { id: item.id },
        })
      },
    },
  }
</script>

<style scoped lang="less">
.filial-connection {
  // квадрат 28×28, как кнопка редактирования в таблице филиалов;
  // селектор с .v-btn.v-size--small — иначе min-width Vuetify перебивает по специфичности
  &__action.v-btn.v-size--small {
    min-width: 28px;
    width: 28px;
    height: 28px;
    padding: 0;
    border-radius: 6px;
  }
}
</style>
